// config/constants.js
export const TOKEN_USAGE_CONFIG = {
  CURRENCY: 'USD',

  // Alert thresholds (percentages) — must match middleware thresholds
  WARNING_THRESHOLD: 70,    // 70%
  CRITICAL_THRESHOLD: 90,   // 90%

  // Default date range (current month)
  DEFAULT_DATE_RANGE: 'current_month',
  
  // Chart colors
  CHART_COLORS: {
    cost: '#FF6B6B',
    tokens: '#4ECDC4',
    requests: '#95E1D3',
    inputTokens: '#F38181',
    outputTokens: '#AA96DA'
  },
  
  // Status colors
  STATUS_COLORS: {
    OK: '#4CAF50',
    WARNING: '#FFC107',
    CRITICAL: '#F44336'
  },
  
  // Table pagination
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100]
};